/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type AggregatesListingH1_listing$ref = any;
export type CompositePropertyType = "APPT" | "BUILDING" | "COMMERCIAL" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "OTHER" | "PARK" | "PROP" | "ROOM";
export type LangInput = "de" | "en" | "es" | "fr" | "it";
export type OfferType = "buy" | "rent";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingBreadcrumbs_listing$ref: FragmentReference;
declare export opaque type AggregatesListingBreadcrumbs_listing$fragmentType: AggregatesListingBreadcrumbs_listing$ref;
export type AggregatesListingBreadcrumbs_listing = {|
  +slug: string,
  +offerType: OfferType,
  +numberOfRooms: ?number,
  +compositePropertyType: CompositePropertyType,
  +localityObject: ?{|
    +slug: string,
    +lang: LangInput,
    +breadcrumbs: $ReadOnlyArray<{|
      +slug: string,
      +lang: LangInput,
      +label: string,
      +canonicalPlace: ?{|
        +slug: string
      |},
    |}>,
  |},
  +$fragmentRefs: AggregatesListingH1_listing$ref,
  +$refType: AggregatesListingBreadcrumbs_listing$ref,
|};
export type AggregatesListingBreadcrumbs_listing$data = AggregatesListingBreadcrumbs_listing;
export type AggregatesListingBreadcrumbs_listing$key = {
  +$data?: AggregatesListingBreadcrumbs_listing$data,
  +$fragmentRefs: AggregatesListingBreadcrumbs_listing$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lang",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingBreadcrumbs_listing",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfRooms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compositePropertyType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "localityObject",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Place",
          "kind": "LinkedField",
          "name": "breadcrumbs",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Place",
              "kind": "LinkedField",
              "name": "canonicalPlace",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AggregatesListingH1_listing"
    }
  ],
  "type": "AggregatesListing",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a09045ae2d9300321651f6fd2ff705cd';

export default node;
